import React from 'react';
import { observer } from 'mobx-react';

const HeaderDefault = () => {
  return <></>;
};

export default observer(HeaderDefault);
